import { Pipe, PipeTransform } from '@angular/core';
import { OrigineDemande } from '../../models/origineDemande';

@Pipe({
	name: 'filterOrigineDemandeByName'
})
export class FilterOrigineDemandeByNamePipe implements PipeTransform {
	transform(origineDemande: OrigineDemande[], filter: string): OrigineDemande[] {
		if (
			!origineDemande ||
			!filter ||
			origineDemande === null ||
			filter === null ||
			filter === ''
		) {
			return origineDemande;
		}

		return origineDemande.filter((origineDemande: OrigineDemande) => {
			if (origineDemande.name) {
				// TODO: add lastName too
				return origineDemande.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
